import React from 'react';
import { Card, CardHeader, CardContent } from '../../components/ui/card';
import { CreditCard } from 'lucide-react';
import { useTranslation } from 'react-i18next';

const SubscriptionSettings: React.FC = () => {
  const { t } = useTranslation();

  return (
    <Card className="flex-1 overflow-hidden flex flex-col">
      <CardHeader>
        <h2 className="text-lg font-medium">{t('profile.subscription', 'Abonnement')}</h2>
        <p className="text-sm text-gray-500 dark:text-gray-400">
          {t('profile.subscriptionDescription', 'Informations sur votre abonnement')}
        </p>
      </CardHeader>
      <CardContent className="flex-1 overflow-auto">
        <div className="p-6">
          <div className="flex items-start">
            <div className="flex-shrink-0">
              <div
                className="w-12 h-12 rounded-full bg-primary/20 dark:bg-primary-dark/30 flex items-center justify-center text-primary dark:text-primary-light">
                <CreditCard size={24}/>
              </div>
            </div>
            <div className="ml-4">
              <h3 className="text-xl font-semibold text-primary dark:text-primary-light">
                {t('profile.subscriptionFree', 'Application gratuite')}
              </h3>
              <p className="mt-2 text-gray-700 dark:text-gray-300">
                {t('profile.subscriptionFreeDescription', 'Pour le lancement de Presta Slot, l\'application est entièrement gratuite jusqu\'à nouvel ordre. Profitez de toutes les fonctionnalités sans aucune restriction ni engagement.')}
              </p>
              <div
                className="mt-4 p-4 bg-primary/5 dark:bg-primary-dark/10 rounded-lg border border-primary/10 dark:border-primary-dark/20">
                <p className="text-sm flex items-center">
                  <span className="text-primary dark:text-primary-light mr-2">•</span>
                  <span>{t('profile.subscriptionFreeDescription2', 'Nous vous informerons à l\'avance lorsque les plans payants seront disponibles.')}</span>
                </p>
              </div>
            </div>
          </div>
        </div>
      </CardContent>
    </Card>
  );
};

export default SubscriptionSettings;
